import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, iconColor }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 glow-primary transition-smooth hover:glow-primary-hover">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm md:text-base text-muted-foreground mb-1">{title}</p>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
            {value}
          </h3>
        </div>
        <div 
          className="w-10 h-10 md:w-12 md:h-12 rounded-md flex items-center justify-center glow-primary"
          style={{ backgroundColor: `${iconColor}20` }}
        >
          <Icon name={icon} size={24} color={iconColor} />
        </div>
      </div>
      {change && (
        <div className={`flex items-center gap-2 ${getChangeColor()}`}>
          <Icon name={getChangeIcon()} size={16} />
          <span className="text-xs md:text-sm font-medium">{change}</span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;